/**
 * Component Async Loader.
 *
 * Async Await Implementation of a dynamic import functionality.
 *
 * Uses webpack v4 chunk mechanism
 * Requires babel dynamic import plugin
 *
 * @memberOf Gaia.asyncLoaders
 * @typedef {Function} asyncComponentLoader
 * @param {string} path - module path
 * @returns {Promise<*>} lib module
 */
export default async path => await import(/* webpackChunkName: "component." */`lib/component/${path}`)
  .then(module => module.default);
